import React from "react";
import DeleteAccountInstructions from "./DeleteAccountInstructions";

function App() {
  return (
    <div>
      <DeleteAccountInstructions />
    </div>
  );
}

export default App;
